import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const Trash2 = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.25 6.75H5.75V20C5.75 20.2561 5.88553 20.575 6.15527 20.8447C6.42501 21.1145 6.74392 21.25 7 21.25H17C17.2561 21.25 17.575 21.1145 17.8447 20.8447C18.1145 20.575 18.25 20.2561 18.25 20V6.75ZM9.25 17V11C9.25 10.5858 9.58579 10.25 10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17ZM13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17ZM15.25 4C15.25 3.74392 15.1145 3.42501 14.8447 3.15527C14.575 2.88553 14.2561 2.75 14 2.75H10C9.74392 2.75 9.42501 2.88553 9.15527 3.15527C8.88553 3.42501 8.75 3.74392 8.75 4V5.25H15.25V4ZM16.75 5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H19.75V20C19.75 20.7439 19.3855 21.425 18.9053 21.9053C18.425 22.3855 17.7439 22.75 17 22.75H7C6.25608 22.75 5.57499 22.3855 5.09473 21.9053C4.61447 21.425 4.25 20.7439 4.25 20V6.75H3C2.58579 6.75 2.25 6.41421 2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H7.25V4C7.25 3.25608 7.61447 2.57499 8.09473 2.09473C8.57499 1.61447 9.25608 1.25 10 1.25H14C14.7439 1.25 15.425 1.61447 15.9053 2.09473C16.3855 2.57499 16.75 3.25608 16.75 4V5.25Z"
        fill={color}
      />
    </svg>
  )
}
